export default "__VITE_ASSET__DQDG5cwL__"